// extracted by mini-css-extract-plugin
module.exports = {"title":"CheckedList-module__D-XCKq__title"};